import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Select,
    Table,
    Tag,
    Radio
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";

const {Title, Text} = Typography;
const {Content} = Layout;
const {RangePicker} = DatePicker;

const DecimalStep = () => {
    const [inputValue, setInputValue] = useState(0);
    const onChange = (value) => {
        if (isNaN(value)) {
            return;
        }
        setInputValue(value);
    };
    return (
        <Row>
            <Col span={12}>
                <Slider
                    min={0}
                    max={10}
                    onChange={onChange}
                    value={typeof inputValue === 'number' ? inputValue : 0}
                    step={0.01}
                />
            </Col>
            <Col span={4}>
                <InputNumber
                    min={0}
                    max={10}
                    style={{
                        margin: '0 16px',
                    }}
                    step={0.01}
                    value={inputValue}
                    onChange={onChange}
                />
            </Col>
        </Row>
    );
};
const handleChange = (value) => {
    console.log(`selected ${value}`);
};
const columns = [
    {
        title: '类型',
        dataIndex: 'stockname',
        render: (stockname) => <p>{stockname ? stockname : '/'}</p>,
    },
    {
        title: '日销（吨）',
        dataIndex: 'value',
        sorter: (a, b) => a.value - b.value,
        render: (value) => <p>{value ? value : '0.00'}</p>,
    },
    {
        title: '月累计（吨）',
        dataIndex: 'monthvalue',
        sorter: (a, b) => a.monthvalue - b.monthvalue,
        render: (monthvalue) => <p>{monthvalue ? monthvalue : '0.00'}</p>,
    },
    {
        title: '年累计（吨）',
        dataIndex: 'dayvalue',
        sorter: (a, b) => a.dayvalue - b.dayvalue,
        render: (dayvalue) => <p>{dayvalue ? dayvalue : '0.00'}</p>,
    }
];

const App = () => {
    const [size, setSize] = useState('middle');
    const handleSizeChange = (e) => {
        setSize(e.target.value);
    };
    return (
        <Space direction="vertical" size={12}>
            <Radio.Group value={size} onChange={handleSizeChange}>
                <Radio.Button value="日销">日销</Radio.Button>
                <Radio.Button value="月累计">月累计</Radio.Button>
                <Radio.Button value="年累计">年累计</Radio.Button>
            </Radio.Group>
        </Space>
    );
};
const Datepik = () => {
    const [size, setSize] = useState('middle');
    const handleSizeChange = (e) => {
        setSize(e.target.value);
    };
    return (
        <Space direction="vertical" size={12}>
            <Radio.Group value={size} onChange={handleSizeChange}>
                <Radio.Button value="日销">日销</Radio.Button>
                <Radio.Button value="月累计">月累计</Radio.Button>
                <Radio.Button value="年累计">年累计</Radio.Button>
            </Radio.Group>
        </Space>
    );
};
const Load = (that,day) => {

    fetch("http://pd.pokemonbye.com:8087/api/getselldatastateyear?day=" + day)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                that.setState({
                    isLoaded: true,
                    listnum: array
                });
                fetch("http://pd.pokemonbye.com:8087/api/getselldatastatemonth?day=" + day)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            let array = result.data;
                            let list = that.state.listnum;
                            for (let i = 0; i < array.length; i++) {
                                for (let j = 0; j < list.length; j++) {
                                    if(array[i].stockid == list[j].stockid){
                                        list[j].monthvalue = array[i].dayvalue;
                                        list[j].monthprice = array[i].dayprice;
                                    }
                                }
                            }
                            that.setState({
                                isLoaded: true,
                                listnum1: list
                            });
                            fetch("http://pd.pokemonbye.com:8087/api/getselldatastateday?day=" + day)
                                .then(res => res.json())
                                .then(
                                    (result) => {
                                        let array = result.data;
                                        let list = that.state.listnum1;
                                        for (let i = 0; i < array.length; i++) {
                                            for (let j = 0; j < list.length; j++) {
                                                if(array[i].stockid == list[j].stockid){
                                                    list[j].value = array[i].dayvalue;
                                                    list[j].price = array[i].dayprice;
                                                }
                                            }
                                        }
                                        console.log(list)
                                        that.setState({
                                            isLoaded: true,
                                            list: list
                                        });
                                    },
                                    // 注意：需要在此处处理错误
                                    // 而不是使用 catch() 去捕获错误
                                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                    (error) => {
                                        that.setState({
                                            isLoaded: true,
                                            error
                                        });
                                    }
                                )
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            that.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
};

class PageDataState extends Component {

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const pid = params.get("area");
        this.state = {
            title: "销量数据报表",
            county: [],
            area: pid,
            listnum: [],
            listnum1: [],
            list: [],
        };
    }

    componentDidMount() {

        Load(this,moment().format('YYYY-MM-DD'));
    }

    render() {
        const onChange = (date, dateString) => {
            console.log(date, dateString);

            Load(this,dateString);
        };
        return (
            <div>
                <Leftmenu/>
                <div className="mainpanel">
                    <Header/>
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                                subTitle="报表结算日期为日期当日0点"
                            ><Space>
                                <Select
                                    defaultValue="富平公司"
                                    style={{
                                        width: 120,
                                    }}
                                    onChange={handleChange}
                                    options={[
                                        {
                                            value: '富平公司',
                                            label: '富平公司',
                                        }
                                    ]}
                                />
                                <DatePicker onChange={onChange} defaultValue={moment()}/>
                            </Space>
                                <br/>
                                <br/>
                                <Table bordered columns={columns} dataSource={this.state.list}/>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageDataState;


